import {css, cx} from "@panda/css";

import {CONSULTANT_PHONE_HREF} from "@pg-rp/consultants";

import {formatReservationCountdown, RESERVATION_HOTLINE} from "../constants/reservation_copy";
import {reservationFocusRingStyle} from "./reservation_step_styles";

export interface IReservationCountdownCopy {
    before: string;
    after: string;
}

// " A.6.8" after the text it completes - names and numbers stay out of the page translation; nothing without a value
export const renderUntranslatedSuffix = (value: string | null) =>
    value ? (
        <>
            {" "}
            <span className="bt">{value}</span>
        </>
    ) : null;

export const renderCountdown = (copy: IReservationCountdownCopy, secondsLeft: number) => (
    <>
        {copy.before}
        <span className="bt">{formatReservationCountdown(secondsLeft)}</span>
        {copy.after}
    </>
);

// where calling is the way forward, the hotline in the message can be tapped
export const renderWithHotlineLink = (text: string) => {
    const hotlineIndex = text.indexOf(RESERVATION_HOTLINE);

    if (hotlineIndex === -1) {
        return text;
    }

    return (
        <>
            {text.slice(0, hotlineIndex)}
            <a href={CONSULTANT_PHONE_HREF} className={cx("bt", hotlineLinkStyle, reservationFocusRingStyle)}>
                {RESERVATION_HOTLINE}
            </a>
            {text.slice(hotlineIndex + RESERVATION_HOTLINE.length)}
        </>
    );
};

// keeps the colour of the message it sits in, also the error colour
const hotlineLinkStyle = css({
    color: "inherit",
    fontWeight: 600,
    textDecoration: "underline",
    whiteSpace: "nowrap"
});
import {css, cx} from "@panda/css";

import {CONSULTANT_PHONE_HREF} from "@pg-rp/consultants";

import {formatReservationCountdown, RESERVATION_HOTLINE} from "../constants/reservation_copy";
import {reservationFocusRingStyle} from "./reservation_step_styles";

export interface IReservationCountdownCopy {
    before: string;
    after: string;
}

// " A.6.8" after the text it completes - names and numbers stay out of the page translation; nothing without a value
export const renderUntranslatedSuffix = (value: string | null) =>
    value ? (
        <>
            {" "}
            <span className="bt">{value}</span>
        </>
    ) : null;

export const renderCountdown = (copy: IReservationCountdownCopy, secondsLeft: number) => (
    <>
        {copy.before}
        <span className="bt">{formatReservationCountdown(secondsLeft)}</span>
        {copy.after}
    </>
);

// where calling is the way forward, the hotline in the message can be tapped
export const renderWithHotlineLink = (text: string) => {
    const hotlineIndex = text.indexOf(RESERVATION_HOTLINE);

    if (hotlineIndex === -1) {
        return text;
    }

    return (
        <>
            {text.slice(0, hotlineIndex)}
            <a href={CONSULTANT_PHONE_HREF} className={cx("bt", hotlineLinkStyle, reservationFocusRingStyle)}>
                {RESERVATION_HOTLINE}
            </a>
            {text.slice(hotlineIndex + RESERVATION_HOTLINE.length)}
        </>
    );
};

// keeps the colour of the message it sits in, also the error colour
const hotlineLinkStyle = css({
    color: "inherit",
    fontWeight: 600,
    textDecoration: "underline",
    whiteSpace: "nowrap"
});
